/**
 * Checks if a valid keethealth signature exists in session storage
 * @returns {boolean} true if signature exists and is valid, false otherwise
 */
export function hasValidSignature() {
  try {
    const signature = window.sessionStorage.getItem('@keethealth/signature');
    
    if (!signature) {
      return false;
    }

    // Basic validation - check if signature is a valid base64 string and has the expected format (resourceId:signature)
    const decoded = atob(signature);
    const parts = decoded.split(':');
    
    // Should have exactly 2 parts: resourceId and signature
    if (parts.length !== 2) {
      return false;
    }

    // Both parts should be non-empty
    if (!parts[0] || !parts[1]) {
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error validating signature:', error);
    return false;
  }
}

/**
 * Gets the signature from session storage
 * @returns {string|null} the signature if it exists, null otherwise
 */
export function getSignature() {
  return window.sessionStorage.getItem('@keethealth/signature');
}

export function clearSignature() {
  window.sessionStorage.removeItem('@keethealth/signature');
}
